import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import Fonts from '../../../../ui/global/Fonts';
import Colors from '../../../../ui/global/Colors';
import Icon from '../../../../ui/global/Icon';
import Button from '../../../../ui/components/Button';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  background-color: ${Colors.black};
  padding: 1rem;
  box-sizing: border-box;
`;

const CenterContentContainer = styled.div`
  max-width: 500px;
  width: 100%;
  padding: 2rem;
  background-color: ${Colors.grey9};
  border-radius: 8px;
  border: 1px solid ${Colors.grey8};
`;

const Message = styled.h1`
  font-size: 2rem;
  margin: 1.5rem 0 0.5rem;
  color: ${Colors.white};
  font-family: ${Fonts.lexendMedium.fontFamily};
  font-weight: ${Fonts.lexendMedium.fontWeight};
  font-size: 32px;
`;

const SubMessage = styled.p`
  font-size: 1rem;
  margin-bottom: 2rem;
  color: ${Colors.grey2};
  font-family: ${Fonts.lexendSemiLight.fontFamily};
  font-weight: ${Fonts.lexendSemiLight.fontWeight};
  font-size: 18px;
`;

const GithubAccountConnected: React.FunctionComponent = () => {
    const [searchParams] = useSearchParams();
    const isSuccess = searchParams.get('success') === 'true';
    const [timer, setTimer] = useState(3);

    useEffect(() => {
        // Verify OAuth state before doing anything else
        const urlParams = new URLSearchParams(window.location.search);
        const returnedState = urlParams.get('state');
        const storedState = sessionStorage.getItem('github_oauth_state');

        if (!returnedState || !storedState || returnedState !== storedState) {
            console.error('OAuth state mismatch or missing');
            alert('Invalid or expired OAuth state. Please try again.');
            return; // Stop here; do not proceed to success flow
        }

        // Clear stored state after verification
        sessionStorage.removeItem('github_oauth_state');
        // ---------------------------------------------------------

        // Inform the parent window that the process is complete, if needed.
        if (isSuccess && window.opener) {
            window.opener.postMessage('github_oauth_success', '*');
        }

        // Add a timeout to close the tab automatically on success
        if (isSuccess) {
            const countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);

            const timerId = setTimeout(() => {
                window.close();
            }, 3000);

            return () => {
                clearInterval(countdown);
                clearTimeout(timerId);
            };
        }
    }, [isSuccess]);

    const handleCloseTab = () => {
        window.close();
    };

    // Render props based on success state
    const renderProps = isSuccess
        ? {
            message: 'GitHub account connected.',
            subMessage: `Auto-closing this tab in ${timer} seconds...`,
            errorMessage: null
        }
        : {
            message: 'GitHub connection failed.',
            subMessage: 'Please try again.',
            errorMessage: searchParams.get('message') || 'An unknown error occurred.'
        };

    return (
        <PageContainer>
            <CenterContentContainer>
                <Icon icon="github-logo" color={Colors.white} size={48} />
                <Message>{renderProps.message}</Message>
                <SubMessage>{renderProps.subMessage}</SubMessage>
                {renderProps.errorMessage && <SubMessage>{renderProps.errorMessage}</SubMessage>}
                <Button
                    size="small"
                    color="white"
                    icon='delete'
                    text='Close Tab'
                    onClick={handleCloseTab}
                />
            </CenterContentContainer>
        </PageContainer>
    );
};

export default GithubAccountConnected;